var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFashionAccessories({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-Fashion_Accessories",
    "data-name": "ic-Fashion&Accessories",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.387,
    height: 52.387,
    viewBox: "0 0 52.387 52.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18394",
    "data-name": "Rectangle 18394",
    width: 20.768,
    height: 22.052
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39710",
    "data-name": "Path 39710",
    d: "M26.193,0A26.193,26.193,0,1,1,0,26.193,26.193,26.193,0,0,1,26.193,0Z",
    fillOpacity: 0.15,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39713",
    "data-name": "Path 39713",
    d: "M0,0H31.23V31.23H0Z",
    transform: "translate(11.082 11.082)",
    fill: "none",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71364",
    "data-name": "Group 71364",
    transform: "translate(18.941 13.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71315",
    "data-name": "Group 71315",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35686",
    "data-name": "Path 35686",
    d: "M.72,21.8c-.066-1.095-.131-2.174-.2-3.253C.429,17,.307,15.453.249,13.9.2,12.716-.059,11.548.011,10.351A5.479,5.479,0,0,1,.35,8.665,5.993,5.993,0,0,0,.9,6.623C.91,6.062.941,5.5.919,4.939c-.054-1.4-.132-2.8-.2-4.2A2.607,2.607,0,0,0,.67.458,39.7,39.7,0,0,1,10.939.227c.044.386.082.771.133,1.155.152,1.152.289,2.306.469,3.454a47.741,47.741,0,0,0,1.367,6.172,29.81,29.81,0,0,0,1.579,4.21,3.577,3.577,0,0,0,2.085,1.9c.926.343,1.878.618,2.812.94a4.307,4.307,0,0,1,.872.4,1.379,1.379,0,0,1,.291,1.841.482.482,0,0,1-.227.137,21.484,21.484,0,0,1-5.539,1.514,12.34,12.34,0,0,1-4.28-.188,3.276,3.276,0,0,1-2.129-1.64c-.379-.619-.724-1.26-1.12-1.867a11.873,11.873,0,0,0-2.233-2.407c-.373-.325-.766-.628-1.151-.939-.061-.049-.129-.09-.244-.169.041,2.383.081,4.714.121,7.065Z",
    transform: "translate(0.001 0)",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFashionAccessories);
export default __webpack_public_path__ + "static/media/ic-Fashion&Accessories.9e11843b3acaa0de8823217a48c0190b.svg";
export { ForwardRef as ReactComponent };